import { getCognitiveDomain } from '@exam-management/qcontent-management';
import { Chip, ContentPreviewer, Flex, ReadonlyField, Text } from '@shared/components';

import { useSingleQuestionDetails } from '../../providers';

export default function PropertiesView() {
  const { singleQuestion } = useSingleQuestionDetails();

  // TODO: maybe we could promote this to shared
  const cognitiveDomain = getCognitiveDomain(singleQuestion.tags);

  return (
    <Flex sx={{ flexDirection: 'column', gap: 4 }}>
      <Flex sx={{ flexDirection: 'column', gap: 1 }}>
        <Text variant='body2Semibold'>คุณลักษณะของข้อสอบ (Cognitive Domain)</Text>
        <Flex sx={{ gap: 2 }}>
          {cognitiveDomain.map((domain) => (
            <Chip key={domain.value} label={domain.label} />
          ))}
        </Flex>
      </Flex>
      <ReadonlyField
        label='วัตถุประสงค์การเรียนรู้ (LOS)'
        content={singleQuestion.learningObjectiveStatement?.tag.name ?? 'ไม่ระบุ'}
      />
      <ReadonlyField
        label='คำอธิบายเฉลย'
        content={<ContentPreviewer content={singleQuestion.solution?.value ?? 'ไม่ระบุ'} />}
      />
      <ReadonlyField
        label='หนังสืออ้างอิง'
        content={<ContentPreviewer content={singleQuestion.metadata.reference ?? 'ไม่ระบุ'} />}
      />
    </Flex>
  );
}
